function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Code"
}, React.createElement("path", {
  className: "logo__slash",
  d: "M63.64,127.279l-35.356,35.356l141.422,141.421l35.355,-35.355l-141.421,-141.422Z"
}), React.createElement("g", {
  className: "logo__l"
}, React.createElement("path", {
  d: "M296.985,332.34l35.355,-35.355l-91.924,-91.924l-35.355,35.355l91.924,91.924Z"
}), React.createElement("path", {
  d: "M332.34,84.853l-35.355,-35.356l-141.422,141.422l35.356,35.355l141.421,-141.421Z"
})), React.createElement("g", {
  className: "logo__v"
}, React.createElement("path", {
  d: "M282.843,35.355l-35.356,-35.355l-91.924,91.924l35.356,35.355l91.924,-91.924Z"
}), React.createElement("path", {
  d: "M35.355,0l-35.355,35.355l141.421,141.422l35.356,-35.356l-141.422,-141.421Z"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "header__logo",
    width: "100%",
    height: "100%",
    viewBox: "0 0 333 333",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.2d275c5c.svg";
export { ForwardRef as ReactComponent };